<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약속상품 품목관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>약속상품명</p>
                <input type="text" placeholder="약속상품명을 입력하세요" class="form_control" v-model="searchInfo.promiseGoodsNm">
              </li>
              <li>
                <p>상품타입</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.goodsType">
                    <b-form-select-option :value="null">전체</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in goodsTypeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <!-- <button class="btn btn_md btn_darkblue" @click="fn_move_promiseReg">신규 상품</button> -->
            </div>
            <table class="list">
              <thead>
                <tr>
                  <th>이미지</th>
                  <th>약속상품명</th>
                  <th>상품타입</th>
                  <th>구성 상품수</th>
                  <th>관리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="promiseList.length == 0">
                    <td colspan="5"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in promiseList" :key="index">
                  <td>
                    <span class="img_area">
                      <img :src="'/file/getImgFile/' + item.goods_file_id" alt="">
                    </span>
                  </td>
                  <td><span>{{ item.promise_goods_nm }}</span></td>
                  <td><span>{{ item.promise_goods_type_nm }}</span></td>
                  <td><span>{{ item.ItemCount }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_puls" @click="fn_move_promiseItemReg(item)"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'  
  import Pagination from "@/components/AdminPagination.vue"
  import commonUtil from "@/mixin/commonUtil";
  //import viewModal from "../AdminModal/viewModal.vue"

  export default {
    name: 'AdminMain',
    mixins: [commonUtil],
    components: {
      Pagination
      //viewModal,
    },
    data() {
      return {
        goodsTypeList : [],       // 상품타입 리스트
        searchInfo : {
          promiseGoodsNm : '',
          goodsType : null,
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }                
        },
        pagingShow : false,
        promiseList: [],
        selected: null,
        goodsInfo : {}
      }
    },
    async created(){
        //공통코드 - 상품타입가져오기
        this.goodsTypeList = await this.getCode('GC00000008');        

        this.fn_search();
    },
    methods : {
        fn_search(){
          console.log("@@@ search");
          axios
              .post("/api/admin/promise/searchPromiseGoosItem", this.searchInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.promiseList = res.data.promiseList;

                  console.log("@@@@ promiseList : %o",this.promiseList);

                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                  if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                  }                        

              })
              .catch((err) => console.log(err));
        },
      fn_move_promiseItemReg(item){
        this.$store.dispatch('promise/setPromiseGoodsInfo', item);
        this.$router.push("/admin/promise/promiseGoodsItemMngt");
      },
      fn_delete(item){
          console.log("@@@ delete");

          if(confirm("정말로 삭제하시겠습니까?")){
          
            axios
                .post("/api/admin/promise/deletePromiseGoods", item)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.fn_search();                

                })
                .catch((err) => console.log(err));
          }
      }
    }
  }
</script>